export default __webpack_public_path__ + "static/media/oberyn.3a86a04c.jpg";